import React from 'react';
import { type FontItem } from '@/components/font-family-selector';
import LabelAction from '@/components/label-action';
import { useLocaleStore } from '@/i18n';
import {
    FontFamily,
    FontSize,
    FontStyle,
    ListStyle,
    TextAlignment,
    TextColorPicker,
    TextOpacity,
    TextPadding,
    TextSpacing,
} from '../../widgets';
import './style.less';

type Props = {
    fonts: FontItem[];
    enableRemoteSearch?: boolean;
};

export const VectorTextPanel: React.FC<Props> = ({ fonts, enableRemoteSearch }) => {
    const { $t } = useLocaleStore();

    return (
        <div className="vector-text-panel">
            <div className="vector-text-panel__base">
                <FontFamily fonts={fonts} enableRemoteSearch={enableRemoteSearch} />
                <LabelAction title={$t((v) => v.textFontSizeAndTextColor.size)} align>
                    <div className="vector-text-panel__ctrl">
                        <FontSize />
                        <TextColorPicker />
                    </div>
                </LabelAction>
                <FontStyle />
                <TextAlignment />
                <LabelAction title={$t((v) => v.textAction.spacing)} align>
                    <div className="vector-text-panel__ctrl">
                        <TextSpacing />
                        <ListStyle />
                    </div>
                </LabelAction>
                <TextPadding />
                <TextOpacity />
            </div>
        </div>
    );
};
